import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import {
  ADD_FAVORITE_PROFESSIONAL,
  BLOCK_RECENT_PROFESSIONAL,
  FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION,
  FETCH_RECENT_PROFESSIONALS,
  fetchRecentProfessionals as _fetchRecentProfessionals,
} from '~/actions';
import useLoading from '~/hooks/useLoading';

const actions = [
  FETCH_RECENT_PROFESSIONALS,
  ADD_FAVORITE_PROFESSIONAL,
  BLOCK_RECENT_PROFESSIONAL,
  FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION,
];

export const useRecentProfessionalsList = () => {
  const isInitialized = useRef(false);
  const dispatch = useDispatch();
  const { isLoading } = useLoading(actions);
  const recentProfessionals = useAppSelector((state) => state.user.recentProfessionals);
  const filter = useAppSelector((state) => state.user.professionalHubFilter);

  const fetchRecentProfessionals = useCallback(async () => {
    await dispatch(_fetchRecentProfessionals({ filter }));
    isInitialized.current = true;
  }, [dispatch, filter]);

  return {
    isInitialized: isInitialized.current,
    recentProfessionals,
    isLoading,
    isEmpty: !recentProfessionals?.length,
    isFiltered: filter !== 'all',
    fetchRecentProfessionals,
  };
};
